export default {
  card: {
    title: '카드로 결제',
    inputs: {
      number: {
        tite: '카드 번호',
        placeholder: '카드 번호 입력',
      },
    },
  },
  'driver-tips': {
    title: '감사합니다<br><span>운전사님 응원해 주셔서!</span>',
    description: '팁의 100%가 직접 운전사에게 전달됩니다',
    remember: '팁은 전적으로 귀하의 선택임을 기억해 주세요!',
    'confirmation-modal': {
      title: '확인해 주세요:',
      description: '다음 금액의 팁을 보내시겠습니까?',
      error: '팁 금액은 $2에서 $40 사이여야 합니다.',
      actions: {
        confirm: '확인',
        cancel: '취소',
      },
    },
  },
  'tips-amount': {
    other: '기타',
  },
  'tips-component': {
    thanks: '감사합니다! 귀하의 팁이 운전사의 하루를 밝게 할 것입니다.',
    more: '추가 팁 보내기',
  },
  'tips-old': {
    title: '감사합니다<br><span>운전사님 응원해 주셔서!</span>',
    description: '팁의 100%가 직접 운전사에게 전달됩니다',
    btn: '카드 결제',
  },
}
